<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let onClose: () => void;
  export let onAccept: () => void;

  let acknowledgmentsAccepted = false;

  $: acknowledgmentsNotAccepted = !acknowledgmentsAccepted;

</script>

<Modal show={true} closeOnBackgroundClick={false} fizzModal={true} size={"medium"}>
  <section class="fizz-inset-square-24" data-testid="dwolla-acknowledgements-modal">
    <header class="fizz-space-between fizz-stack-16">
      <h4 class="fizz-heading-4">ProviPay Acknowledgements</h4>
      <div data-testid="close-dwolla-acknowledgements-modal" on:click|preventDefault={onClose}>
        <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="16" width="16" />
      </div>
    </header>
    <div class="fizz-flow-16 fizz-stack-8">
      <p class="fizz-text-left">
        By checking the box you agree to our <a
          href={"https://app.provi.com/terms"}
          target="_blank"
          rel="noopener noreferrer">Terms of Service</a
        >
        and
        <a href={"https://app.provi.com/privacy"} target="_blank" rel="noopener noreferrer"
          >Privacy Policy</a
        >, as well as our partner
        <a
          href={"https://www.dwolla.com/legal/dwolla-account-terms-of-service/#legal-content"}
          target="_blank"
          rel="noopener noreferrer">Dwolla&rsquo;s Terms of Service</a
        >
        and
        <a href={"https://www.dwolla.com/legal/privacy"} target="_blank" rel="noopener noreferrer"
          >Privacy Policy</a
        >.
      </p>
      <label class="fizz-flex-row-8">
        <input type="checkbox" class="fizz-checkbox" bind:checked={acknowledgmentsAccepted} />
        <span>I agree</span>
      </label>
    </div>
    <footer class="fizz-flex-row fizz-justify-end">
      <button
        class="fizz-button-secondary fizz-button"
        disabled={acknowledgmentsNotAccepted}
        on:click|preventDefault={onAccept}
      >
        Agree and continue
      </button>
    </footer>
  </section>
</Modal>
